import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Flame } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="py-24 bg-heritage-beige relative overflow-hidden" data-id="element-167">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-heritage-gold/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-168"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-heritage-terracotta/5 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-169"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-170">
        <FadeIn data-id="element-171">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-heritage-terracotta/10 text-heritage-terracotta mb-8" data-id="element-172">
            <Flame className="w-8 h-8" data-id="element-173" />
          </div>

          <h2 className="text-sm font-bold tracking-widest uppercase text-heritage-terracotta mb-4" data-id="element-174">
            La Solución
          </h2>

          <h3 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-175">
            Presentamos el <br data-id="element-176" />
            <span className="italic text-heritage-terracotta" data-id="element-177">
              Método de la Entrevista Gastronómica
            </span>
          </h3>

          <div className="space-y-6 text-lg md:text-xl text-heritage-coffee/80 max-w-3xl mx-auto" data-id="element-178">
            <p data-id="element-179">
              No es solo escribir ingredientes. Es un sistema diseñado para
              mujeres de nuestra generación que enseña a{' '}
              <strong data-id="element-180">"traducir" el instinto al papel.</strong>
            </p>
            <p data-id="element-181">
              Aprenderás a documentar los sonidos, los aromas y los sentimientos
              de cada plato, convirtiendo cada receta en un{' '}
              <span className="font-serif font-semibold text-heritage-terracotta" data-id="element-182">
                testamento emocional
              </span>{' '}
              que cualquiera podrá replicar con éxito.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}